module.exports = __webpack_public_path__ + "img/pure hemp.b3825810.png";